export const RECURRING_NONE_OPTION = {
    id: '0',
    duration: 0,
    discountPercentage: 0
};
